import { render, staticRenderFns } from "./Textmessages.vue?vue&type=template&id=2e8d4a4c&scoped=true"
import script from "./Textmessages.vue?vue&type=script&lang=js"
export * from "./Textmessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d4a4c",
  null
  
)

export default component.exports